import {Injectable} from '@angular/core';
import {RolePermission} from './role-permission';
import {UserRole} from './user-role.enum';
import {Principal} from '../principal.service';

const RolesWithPermissions = {

  [UserRole.KN_ADMIN]: Object.keys(RolePermission), // all

  [UserRole.KN_FINANCE]: [
    RolePermission.RB_FINANCE,
    RolePermission.FINANCE_MODULE,
    RolePermission.MAIN_DASH_FINANCE,
    RolePermission.AD_UNITS_CREATE_UNIT,
    RolePermission.PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT,
    RolePermission.PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP,
    RolePermission.PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL,
    RolePermission.PUBLISHERS_ON_BOARDING_IO_STATUS,
    RolePermission.AD_UNIT_FINANCE,
    RolePermission.AD_UNIT_OPTIMIZATIONS,
    RolePermission.PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION,
    RolePermission.PUBLISHERS_PUBLISHERS_DFP_INFORMATION,
    RolePermission.SITE_APPROVAL_TABLE_APPROVE_REJECT,
    RolePermission.SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION,
    RolePermission.SITE_APPROVAL_IAS_EXPORT_IMPORT,
  ],
  [UserRole.KN_SALES_PERSON]: [
    RolePermission.MAIN_DASH_FINANCE,
    RolePermission.RB_FINANCE,
    RolePermission.AD_UNITS_MODULE,
    RolePermission.PUBLISHERS_MODULE,
    RolePermission.SITE_APPROVAL_MODULE,
    RolePermission.SUPPORT_MODULE,
  ],
  [UserRole.KN_OPERATIONS]: [
    RolePermission.MAIN_DASH_FINANCE,
    RolePermission.BLOCKS_MODULE,
    RolePermission.RB_FINANCE,
    RolePermission.ANALYTICS_MODULE,

    RolePermission.PUBLISHERS_MODULE,
    RolePermission.USERS_MODULE,
    RolePermission.AD_UNITS_MODULE,
    RolePermission.UNIT_REQUESTS_MODULE,
    RolePermission.ADS_TXT_MODULE,
    RolePermission.WIDGETS_MODULE,
    RolePermission.SUPPORT_MODULE,
    RolePermission.SITE_APPROVAL_MODULE,
    RolePermission.DEMAND_PARTNER_MODULE,
    RolePermission.AD_UNITS_CREATE_UNIT,
    RolePermission.PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT,
    RolePermission.PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP,
    RolePermission.PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL,
    RolePermission.PUBLISHERS_ON_BOARDING_IO_STATUS,
    RolePermission.PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION,
    RolePermission.PUBLISHERS_PUBLISHERS_DFP_INFORMATION,
    RolePermission.SITE_APPROVAL_TABLE_APPROVE_REJECT,
    RolePermission.SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION,
    RolePermission.SITE_APPROVAL_IAS_EXPORT_IMPORT,
    RolePermission.AD_UNIT_FINANCE,
    RolePermission.AD_UNIT_OPTIMIZATIONS,
  ],
  [UserRole.KN_ACCOUNT_MANAGER]: [
    RolePermission.PUBLISHERS_MODULE,
    RolePermission.USERS_MODULE,
    RolePermission.AD_UNITS_MODULE,
    RolePermission.UNIT_REQUESTS_MODULE,
    RolePermission.ADS_TXT_MODULE,
    RolePermission.WIDGETS_MODULE,
    RolePermission.AD_UNITS_CREATE_UNIT,
    RolePermission.PUBLISHERS_ON_BOARDING_TABLE_APPROVE_REJECT,
    RolePermission.PUBLISHERS_ON_BOARDING_SCALED_PARTNERSHIP,
    RolePermission.PUBLISHERS_ON_BOARDING_SEND_WELCOME_EMAIL,
    RolePermission.PUBLISHERS_ON_BOARDING_IO_STATUS,
    RolePermission.PUBLISHERS_PUBLISHERS_EDIT_SALES_REP_SELECTION,
    RolePermission.PUBLISHERS_PUBLISHERS_DFP_INFORMATION,
    RolePermission.SITE_APPROVAL_TABLE_APPROVE_REJECT,
    RolePermission.SITE_APPROVAL_PUBLISHER_MODAL_SALES_REP_SELECTION,
    RolePermission.SITE_APPROVAL_IAS_EXPORT_IMPORT,
    RolePermission.AD_UNIT_FINANCE,
    RolePermission.AD_UNIT_OPTIMIZATIONS,
  ],
};

@Injectable()
export class RolePermissionService {

  constructor(private principal: Principal) {
  }

  hasPermissions(permissions: RolePermission[]) {
    const roles = this.principal.getUser()._roles;
    if (permissions && permissions.length) {
      if (roles) {
        return roles.some(role => {
          const permissionsForRole = RolesWithPermissions[role];
          return permissionsForRole && permissionsForRole.some(p => permissions.includes(p));
        });
      }
    }
    return false;
  }
}
